import { render, staticRenderFns } from "./bRemDash.vue?vue&type=template&id=ea36726a&scoped=true"
import script from "./bRemDash.vue?vue&type=script&lang=js"
export * from "./bRemDash.vue?vue&type=script&lang=js"
import style0 from "./bRemDash.vue?vue&type=style&index=0&id=ea36726a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea36726a",
  null
  
)

export default component.exports